import { cleartaxAxios } from '../../../../../http-common';
import { StatusType } from '../utils/types';
const headers = {
  'Content-Type': 'application/json',
};

class CommunityQAServices {
  createComment(payload: {
    content: string;
    parent: number | null;
    post: number;
  }) {
    return cleartaxAxios
      .post(`/f/community/comment`, payload, { headers })
      .then((response) => {
        return {
          data: response.data,
          status: StatusType.Success,
        };
      })
      .catch((error) => {
        const { response } = error;
        if (response.status === 400) {
          return {
            data: response.data,
            status: StatusType.Derogatory,
          };
        }
        return {
          data: response.data,
          status: StatusType.Failed,
        };
      });
  }

  editComment(payload: { content: string }, commentId: number) {
    return cleartaxAxios
      .patch('/f/community/comment/' + commentId, payload, {
        headers,
      })
      .then((response) => {
        return {
          data: response.data,
          status: StatusType.Success,
        };
      })
      .catch((error) => {
        const { response } = error;
        if (response.status === 400) {
          return {
            data: response.data,
            status: StatusType.Derogatory,
          };
        }
        return {
          data: response.data,
          status: StatusType.Failed,
        };
      });
  }

  usernameSuggestion() {
    return cleartaxAxios
      .get('/f/community/username-suggestions')
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data,
        };
      })
      .catch((error) => {
        return {
          status: StatusType.Failed,
          data: error.response?.data,
        };
      });
  }

  getUserName() {
    return cleartaxAxios.get('/f/community/get-user-details');
  }

  setUserName(payload: { username: string }) {
    return cleartaxAxios
      .post('/f/community/choose-username', payload, { headers })
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data,
        };
      })
      .catch((error) => {
        if (error.response.status === 400) {
          return {
            status: StatusType.Duplicate,
            data: error.response.data,
          };
        } else {
          return {
            status: StatusType.Failed,
            data: error.response.data,
          };
        }
      });
  }

  getRepliesData(parentId: number, pageLimit: number) {
    //this
    return cleartaxAxios
      .get(`/f/community/comment/${parentId}/replies?limit=${pageLimit}`)
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data,
        };
      })
      .catch((error) => {
        return {
          status: StatusType.Failed,
          data: error.response.data,
        };
      });
  }

  getParentCommentData(postId: number, pageNumber: number, LIMIT = 10) {
    return cleartaxAxios
      .get(
        `/f/community/comment?post=${postId}&page=${pageNumber}&limit=${LIMIT}`
      )
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data,
        };
      })
      .catch((error) => {
        return {
          status: StatusType.Failed,
          data: error.response?.data,
        };
      });
  }

  deleteComment(commentId: number) {
    return cleartaxAxios
      .delete(`/f/community/comment/${commentId}`, { headers })
      .then((response) => {
        return { status: StatusType.Success, data: response.data };
      })
      .catch((error) => {
        return { status: StatusType.Failed, data: error.response?.data };
      });
  }

  reportComment(commentId: number) {
    return cleartaxAxios
      .post(`/f/community/comment/${commentId}/report`, {
        headers,
      })
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data,
        };
      })
      .catch((error) => {
        return {
          status: StatusType.Failed,
          data: error.response?.data,
        };
      });
  }

  submitFeedback(id: number, payload: { status: boolean }) {
    return cleartaxAxios
      .post(`/f/community/comment/${id}/feedback/`, payload, {
        headers,
      })
      .then((response) => {
        return {
          status: StatusType.Success,
          data: response.data.status,
        };
      })
      .catch((error) => {
        return {
          status: StatusType.Success,
          data: error.response.data,
        };
      });
  }
}

export default new CommunityQAServices();
